import { useParams } from 'react-router';
import { fetchPravoEuDetail } from '../../../client/pravoEuDetailClient';
import PravoEuDetail from '../../../model/PravoEuDetail';
import { ClientStatus } from '../../../model/ClientStatus';
import { useClientFetch } from '../../../context/ClientStatusContext';
import Uuid from '../../../model/Uuid';

interface ReturnType {
  pravoEu: PravoEuDetail;
  pravoEuStatus: ClientStatus;
  reloadPravoEuDetail
}

export default (): ReturnType => {
  const { uuid } = useParams<{ uuid: string }>();
  const {
    data: pravoEuDetail,
    status: pravoEuDetailStatus,
    refetch: reloadPravoEuDetail,
  } = useClientFetch(
    () => fetchPravoEuDetail(<Uuid>uuid),
    [uuid],
  );
  return {
    pravoEu: pravoEuDetail,
    pravoEuStatus: pravoEuDetailStatus,
    reloadPravoEuDetail,
  };
};
